<template>
    <div>
        <TitleAndExplanation :title="title" :explanation="explanation"/>
        <div :class="{ bloque_auxiliar_visible: mostrarBloque }">
            <div class="slider-container">
                <div class="slider-box">
                    <div class="slider-info">
                        <input
                            type="text"
                            class="slider-value"
                            v-model="formattedValue"
                            min="0"
                            :max="maxValue"
                            @input="formatCurrencyInput"
                            @blur="setCurrency=true"
                            @focus="setCurrency=false"
                        />
                    </div>
                    <div class="slider-placeholder">
                        Introduce importe aproximado o desliza para seleccionar
                    </div>
                </div>
                <input
                    type="range"
                    class="slider"
                    :min="minValue"
                    :max="maxValue"
                    :step="step"
                    v-model="amount"
                    @input="formatCurrencySlider"
                />
                <div class="slider-labels">
                    <span style="font-size: 11px;">Min</span>
                    <span style="font-size: 11px;">Max</span>
                </div>
            </div>
            <div v-if="mostrarBloque"> <slot></slot> </div>
        </div>
    </div>
</template>

<script>
import TitleAndExplanation from '../common/TitleAndExplanation.vue';
import {formatCurrency} from '../../utils';

export default {
    name: 'InputSlider',
    components: {
        TitleAndExplanation
    },
    data() {
        return {
            amount: 0,
            setCurrency: true
        };
    },
    props: {
        step: {
            type: Number,
            default: 1
        },
        currentValue: {
            type: [String, Number],
            default: ''
        },
        minValue: {
            type: Number,
            default: 0
        },
        maxValue: {
            type: Number,
            default: 1000000
        },
        title: {
            type: String,
            default: ''
        },
        explanation: {
            type: String,
            default: ''
        },
        mostrarBloque: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        formattedValue: {
            get() {
                if(this.setCurrency)
                    return formatCurrency(this.amount);
                else
                    return this.amount;
            },
            set(value) {
                this.amount = this.parseCurrency(value);
            }
        }
    },
    mounted() {
        if(this.currentValue) this.amount = this.parseCurrency(this.currentValue);
    },
    methods: {
        // Limpia el valor de formato y mantiene solo el número
        parseCurrency(value) {
            const numericValue = value.replace(/[^0-9]/g, '');
            return parseInt(numericValue, 10) || 0;
        },
        // Aplicamos formato cada vez que cambia el input además emitimos cambio
        formatCurrencyInput() {
            if(this.amount > this.maxValue) this.amount = this.maxValue;
            this.$emit('valueChanged', this.amount);
        },
        // Emitimos cambio y seteamos valor al input
        formatCurrencySlider() {
            this.$emit('valueChanged', this.amount);
            this.formattedValue = this.amount;
            this.setCurrency = true
        }
    }
}
</script>

<style>
    .bloque_auxiliar_visible{
        display: flex;
        margin-top: -24px;
    }
    .slider-container {
        width: 100%;    
        margin-top: 24px;
    }
    .slider-box {
        margin: 8px 0;
        padding: 16px;
        border-radius: var(--border-radius);
        border: 1px solid var(--gray-light);
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        position: relative;
    }
    .slider-info {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }

    /* texto que muestra el valor */
    .slider-value {
        font-size: 20px; 
        font-weight: var(--font-weight-medium);
        text-align: center;
        border: none;
        outline: none;
        background: none;
        -moz-appearance: textfield; /* Firefox */
    }
    .slider-value::-webkit-outer-spin-button,
    .slider-value::-webkit-inner-spin-button {
        -webkit-appearance: none; /* Chrome, Safari, Opera */
        margin: 0;
    }
    .currency-symbol {
        font-size: 20px;
        font-weight: var(--font-weight-medium);
    }
    .slider-placeholder {
        position: absolute;
        top: 44px;
        width: 80%;
        font-size: 12px;
    }
    .slider {
        width: 100%;
        cursor: pointer;
        -webkit-appearance: none;
        appearance: none;
        background: transparent;
        margin-bottom: 10px;
    }

    /* control deslizante */
    .slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 12px; 
        height: 12px;
        border-radius: 50%;
        background: blue; 
        cursor: pointer; 
        margin-top: -5px; 
    }
    
    /* línea del slider */
    .slider::-webkit-slider-runnable-track {
        height: 2px; 
        background: var(--gray-light); 
        border-radius: 4px;
    }
    .slider-labels {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
    }
    /* MOVIL */
    @media (max-width: 768px) {
        .slider-box {
            padding: 26px 6px;
            line-height: 12px;
        }
        .slider-placeholder {
            top: 55px;
            width: 85%;
        }
        .slider-value {
            font-size: 18px; 
            width: 80px;
        }
    }
</style>
